let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bjJYx")).then(() => parcelRequire('jJGGN'));